<template>
  <div :class="['range-input', disabled && 'disabled']">
    <label class="text5">
      {{ label }}
      <span class="range-value">{{ getFormattedValue() }}</span>
    </label>
    <VueSliderComponent
      class="mr-2"
      :id="id"
      v-model="rangeValue"
      :dotSize="22"
      width="auto"
      :height="3"
      :min="minimum"
      :max="computedMaximum"
      :interval="interval"
      :disabled="disabled"
      :useKeyboard="useKeyboard"
      :duration="0.15"
      :tooltip="tooltip"
      :tooltip-formatter="getFormattedValue"
      :enable-cross="false"
      :min-range="interval"
      absorb
    />
  </div>
</template>

<style lang="scss">
.range-input {
  margin-bottom: rem(34px);

  &.disabled {
    opacity: 0.3;
  }

  label {
    display: flex;
    justify-content: space-between;
  }

  .vue-slider-process {
    @include setColor(--color-selection, background-color);
  }

  .vue-slider-dot-handle {
    border-width: 1px;
    border-style: solid;
    @include setColor(--color-cta, border-color);
  }

  .vue-slider-dot-handle-focus {
    box-shadow: 0px 0px 8px map-get($colors, --color-cta);
    box-shadow: 0px 0px 8px var(--color-cta);
  }
}
</style>

<script>
import debounce from "lodash.debounce";
import VueSliderComponent from "vue-slider-component";

export default {
  components: {
    VueSliderComponent,
  },

  data() {
    return {
      rangeValue: this.value,
    };
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    minimum: {
      type: Number,
      default: 0,
    },
    maximum: {
      type: Number,
      required: true,
    },
    interval: {
      type: Number,
      default: 10,
    },
    exceedingLabel: {
      type: String,
      default: "",
    },
    exceeding: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "{val}",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    useKeyboard: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "none",
      validator(tooltip) {
        return ["active", "none", "hover", "always"].includes(tooltip);
      },
    },
  },

  computed: {
    computedMaximum() {
      return this.exceeding ? this.maximum + this.interval : this.maximum;
    },
  },

  watch: {
    rangeValue() {
      this.onValueChangeDebounced();
    },
  },

  methods: {
    getFormattedValue() {
      if (this.exceeding && this.rangeValue === this.computedMaximum) {
        return this.exceedingLabel;
      }

      return this.format
        ? this.format.replace("{val}", this.rangeValue)
        : this.rangeValue;
    },

    onValueChange() {
      this.$emit("update:value", this.rangeValue);
    },
  },

  created() {
    this.onValueChangeDebounced = debounce(this.onValueChange, 100);
  },
};
</script>
